import 'messenger-hubspot/build/js/messenger';

import 'messenger-hubspot/build/css/messenger.css';
import 'messenger-hubspot/build/css/messenger-theme-future.css';

export default window.Messenger;